var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _vm.messages
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                ref: "messages",
                staticClass:
                  "col-lg-6 offset-lg-3 col-12 pt-0 container-chat-booking chat-messages"
              },
              [
                _vm.$route.query.is_partner &&
                _vm.$route.query.service_id &&
                _vm.service
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-start align-items-center bg-info p-1 mb-2 rounded text-white"
                      },
                      [
                        _c("div", [
                          _c("img", {
                            staticClass: "img-fluid rounded",
                            attrs: {
                              src: _vm.service.partner_picture
                                ? _vm.service.partner_picture
                                : _vm.service.picture,
                              alt: "",
                              width: "96"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "flex-fill pl-3" }, [
                          _c("div", [
                            _vm._v(
                              "\n            BeNeat แม่บ้านออนไลน์\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            { staticClass: "mb-0", attrs: { for: "" } },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm._f("multiLangName")(_vm.service)) +
                                  "\n          "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.service.id === 1 &&
                        _vm.partner &&
                        _vm.partner.name === "LivingInsider"
                          ? _c("div", { staticClass: "text-right pr-2" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "no-style text-white",
                                  attrs: { href: "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.openPopupModal()
                                    }
                                  }
                                },
                                [_vm._v("ดูรายละเอียด")]
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$route.query.service_id &&
                _vm.bookingData &&
                _vm.bookingData.service_id
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "bg-info sticky-top p-2 text-white text-center text-small shadow-sm",
                        staticStyle: { margin: "0 -2rem" }
                      },
                      [
                        _c("i", { staticClass: "fas fa-circle text-warning" }),
                        _vm._v(
                          "\n        คุณเลือก: " +
                            _vm._s(
                              _vm.getService(Number(_vm.bookingData.service_id))
                                .name_th
                            ) +
                            "\n        "
                        ),
                        _vm.partner
                          ? _c("span", [
                              _vm._v(" | " + _vm._s(_vm.partner.name))
                            ])
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "list-unstyled" },
                  _vm._l(_vm.messages, function(message, index) {
                    return _c(
                      "li",
                      [_c("message", { attrs: { message: message } })],
                      1
                    )
                  }),
                  0
                )
              ]
            )
          ])
        : _c("div", { staticClass: "container-chat-booking" }, [_vm._m(0)]),
      _vm._v(" "),
      _c("popup-modal", { ref: "popupModal" }),
      _vm._v(" "),
      _c("cleaner-reviews-modal", { ref: "cleanerReviewsModal" }),
      _vm._v(" "),
      _c("service-detail-modal", { ref: "serviceDetailModal" }),
      _vm._v(" "),
      _c("Tinybox", {
        attrs: { images: _vm.images, loop: "", "no-thumbs": "" },
        model: {
          value: _vm.indexImage,
          callback: function($$v) {
            _vm.indexImage = $$v
          },
          expression: "indexImage"
        }
      }),
      _vm._v(" "),
      _c("unavailable-service-area-modal", {
        ref: "unavailableServiceAreaModal"
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row p-5" }, [
      _c("div", { staticClass: "col-12 text-center" }, [
        _c("span", { staticClass: "text-loading" }, [
          _vm._v("กำลังโหลด... กรุณารอสักครู่")
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24650924", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24650924","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/Index.vue
// module id = 2267
// module chunks = 0